import { Cliente } from "./entities/Cliente";
import { BancoDados } from "./entities/BancoDados";
import { AutenticacaoProvedor } from "./entities/AutenticacaoProvedor";

const actions = {
  criarCliente: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;
    try {
      await api.post("/bko/cliente", {
        clienteId: clienteId,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  configurarCliente: async (context, { clienteId, bancoDadosId }) => {
    const api = context.rootState.autenticacao.api;
    try {
      await api.post(`/bko/cliente/${clienteId}/bancoDados`, {
        bancoDadosId: bancoDadosId,
      });
    } catch (error) {
      console.error(error);
    }
  },

  detalharCliente: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;
    let resposta = await api.get(`/bko/cliente/${clienteId}`);
    let alth = resposta.data.resultado.dados.configuracaoAutenticacao;
    resposta = resposta.data.resultado.dados;

    let cliente = new Cliente({
      clienteId: resposta.clienteId,
      ativo: resposta.ativo,
      manutencao: resposta.manutencao,
    });
    let bancoDados = new BancoDados({
      bancoDadosId: resposta.configuracaoBancoDados.bancoDadosId,
      host: resposta.configuracaoBancoDados.host,
      port: resposta.configuracaoBancoDados.port,
      schema: resposta.configuracaoBancoDados.schema,
      user: resposta.configuracaoBancoDados.user,
    });

    return {
      cliente,
      bancoDados,
      alth,
    };
  },

  listarCliente: async (context) => {
    const api = context.rootState.autenticacao.api;
    try {
      let resposta = await api.get("/bko/cliente");

      resposta = resposta.data;
      let listaClientes = [];
      resposta.resultado.dados.forEach((clienteDTO) => {
        listaClientes.push(
          new Cliente({
            clienteId: clienteDTO.clienteId,
            ativo: clienteDTO.ativo,
          })
        );
      });

      return {
        listaClientes,
      };
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  listarPerfilCliente: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`/bko/cliente/${clienteId}/perfil`);

    return response;
  },

  ativarCliente: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.post(`/bko/cliente/${clienteId}/ativar`, {
      clienteId,
    });

    return response;
  },

  alterarManutencao: async (context, { clienteId, manutencao }) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.post(
      `/bko/cliente/${clienteId}/alterarManutencao`,
      {
        ativa: manutencao.ativa,
        motivo: manutencao.motivo,
        previsao: manutencao.previsao,
      }
    );

    return response;
  },

  criarAutenticacao: async (
    context,
    { autenticacaoProvedorId, host, user, pass }
  ) => {
    const api = context.rootState.autenticacao.api;
    try {
      await api.post("/bko/autenticacao", {
        autenticacaoProvedorId: autenticacaoProvedorId,
        host: host,
        user: user,
        pass: pass,
      });
    } catch (error) {
      console.error(error);

      throw error;
    }
  },

  listarAutenticacao: async (context) => {
    const api = context.rootState.autenticacao.api;
    try {
      let resposta = await api.get("/bko/autenticacao");

      resposta = resposta.data;

      let listaAutenticacao = [];
      resposta.resultado.dados.forEach((autenticacaoDTO) => {
        listaAutenticacao.push(
          new AutenticacaoProvedor({
            autenticacaoProvedorId: autenticacaoDTO.autenticacaoProvedorId,
            host: autenticacaoDTO.host,
            user: autenticacaoDTO.user,
          })
        );
      });

      return {
        listaAutenticacao,
      };
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  criarBanco: async (context, { bancoDadosId, host, port, user, pass }) => {
    const api = context.rootState.autenticacao.api;
    try {
      await api.post("/bko/bancoDados", {
        bancoDadosId: bancoDadosId,
        host: host,
        port: Number(port),
        rootUser: user,
        rootPass: pass,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  listarBanco: async (context) => {
    const api = context.rootState.autenticacao.api;
    try {
      let resposta = await api.get("/bko/bancoDados");

      resposta = resposta.data;

      let listaBancos = [];
      resposta.resultado.dados.forEach((bancoDTO) => {
        listaBancos.push(
          new BancoDados({
            bancoDadosId: bancoDTO.bancoDadosId,
            host: bancoDTO.host,
            port: bancoDTO.port,
          })
        );
      });

      return {
        listaBancos,
      };
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  Autenticar: async (
    context,
    { autenticacaoProvedorId, publicKey, keyAlg, realm, clienteId }
  ) => {
    const api = context.rootState.autenticacao.api;
    try {
      let resposta = await api.post(`/bko/cliente/${clienteId}/autenticacao`, {
        autenticacaoProvedorId,
        publicKey,
        keyAlg,
        realm,
      });
      return resposta;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  cadastrarChave: async (context, { clienteId, nome }) => {
    const api = context.rootState.autenticacao.api;
    try {
      let resposta = await api.post(`/bko/cliente/${clienteId}/chaveAcesso`, {
        nome,
      });
      return resposta;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  buscarChaves: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;
    try {
      let resposta = await api.get(`/bko/cliente/${clienteId}/chaveAcesso`);
      return resposta;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  cadastrarModulo: async (context, { nome, moduloId }) => {
    const api = context.rootState.autenticacao.api;
    try {
      let resposta = await api.post(`/bko/modulo`, {
        nome,
        moduloId,
      });
      return resposta;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  ListarModulos: async (context) => {
    const api = context.rootState.autenticacao.api;
    try {
      let resposta = await api.get(`/bko/modulo`, {
        params: {
          ativo: true,
        },
      });
      return resposta;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  removerModulo: async (context, { moduloId }) => {
    const api = context.rootState.autenticacao.api;
    try {
      let resposta = await api.delete(`/bko/modulo/${moduloId}`);
      return resposta;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  listarModuloClienteDesativos: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;
    try {
      let resposta = await api.get(`/bko/modulo/cliente/${clienteId}`, {
        params: {
          ativo: false,
        },
      });
      return resposta;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  listarModuloClienteAtivos: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;
    try {
      let resposta = await api.get(`/bko/modulo/cliente/${clienteId}`, {
        params: {
          ativo: true,
        },
      });
      return resposta;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  vincularModulo: async (context, { moduloId, clienteId }) => {
    const api = context.rootState.autenticacao.api;
    try {
      let resposta = await api.post(
        `/bko/modulo/${moduloId}/cliente/${clienteId}`
      );
      return resposta;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  desvincularModulo: async (context, { moduloId, clienteId }) => {
    const api = context.rootState.autenticacao.api;
    try {
      let resposta = await api.delete(
        `/bko/modulo/${moduloId}/cliente/${clienteId}`
      );
      return resposta;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  listarPermissoes: async (context) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.get(`/bko/permissao`);
    return response;
  },
  criarPermissao: async (context, { nome }) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.post(`/bko/permissao`, {
      permissao: nome,
    });
    return response;
  },
  sincronizarPermissoesNew: async (context) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.put(`/bko/permissao/sincronizar`);
    return response;
  },
  sincronizarPermissoes: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.put(
      `/bko/permissao/sincronizar/cliente/${clienteId}`
    );
    return response;
  },

  enviarCores: async (
    context,
    { clienteId, brand1, brand2, brand3, brand9, brand10 }
  ) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.put(
      `/bko/cliente/${clienteId}/configuracao/tema`,
      {
        brand1,
        brand2,
        brand3,
        brand9,
        brand10,
      }
    );
    return response;
  },
  receberCores: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.get(`/bko/cliente/${clienteId}/configuracao`, {
      params: {
        clienteId,
      },
    });

    return response;
  },
  enviarLogo: async (context, { clienteId, logo }) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.put(
      `/bko/cliente/${clienteId}/configuracao/logo`,
      {
        logo,
      }
    );

    return response;
  },
  enviarLogoImpressao: async (context, { clienteId, logoImpressao }) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.put(
      `/bko/cliente/${clienteId}/configuracao/logo`,
      {
        logoImpressao,
      }
    );

    return response;
  },
  receberUpload: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.get(
      `/bko/cliente/${clienteId}/configuracao/logo/upload-url`
    );

    return response;
  },
  excluirTema: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.delete(
      `/bko/cliente/${clienteId}/configuracao/tema`
    );

    return response;
  },

  listarTermosDeUso: async (context) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.get(`/bko/termo-uso`);

    return response;
  },

  adicionarTermoDeUso: async (context, { descricao }) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.put(`/bko/termo-uso`, {
      descricao,
    });

    return response;
  },
  detalharTermoDeUso: async (context, { termoDeUsoId }) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.get(`/bko/termo-uso/${termoDeUsoId}`);

    return response;
  },

  sincronizarTermos: async (context) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.put(`/bko/termo-uso/sincronizar`);

    return response;
  },
  // Configurar Ficha de Epi
  listarColunasEntrega: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ficha-epi/configuracao/info-entrega`, {
      params: {
        vendor_id,
      },
    });

    return response;
  },

  ativarDesativarColunaEntrega: async (
    context,
    { vendor_id, info_entrega, ativo }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`ficha-epi/configuracao/info-entrega`, {
      vendor_id,
      info_entrega,
      ativo,
    });

    return response;
  },

  listarColunasUsuario: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ficha-epi/configuracao/info-usuario`, {
      params: {
        vendor_id,
      },
    });

    return response;
  },

  ativarDesativarColunaUsuario: async (
    context,
    { vendor_id, info_usuario, ativo }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`ficha-epi/configuracao/info-usuario`, {
      vendor_id,
      info_usuario,
      ativo,
    });

    return response;
  },

  receberCabecalho: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ficha-epi/configuracao/descricao`, {
      params: {
        vendor_id,
      },
    });

    return response;
  },

  alterarCabecalho: async (
    context,
    { vendor_id, titulo, cabecalho, rodape, template }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`ficha-epi/configuracao/descricao`, {
      vendor_id,
      cabecalho,
      titulo,
      rodape,
      template,
    });

    return response;
  },

  //Setup Integrações

  listarUnidadesPorCliente: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`bko/cliente/${clienteId}/unidade`);

    return response;
  },

  listarSistemasIntegracoes: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`bko/integracao/sistemas`);

    return response;
  },

  listarSistemasPorUnidade: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`bko/integracao/unidade-sistema`);

    return response;
  },

  listarVersoes: async (context, { sistemaUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`bko/integracao/sistemas/versoes`, {
      params: {
        sistemaUuid,
      },
    });

    return response;
  },

  cadastrarSistemaIntegradoUnidade: async (
    context,
    {
      clienteId,
      unidadeId,
      sistemaUuid,
      versao,
      tipo,
      metodo,
      protocolo,
      dataAtivacao,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`bko/integracao/unidade-sistema`, {
      clienteId,
      unidadeId,
      sistemaUuid,
      versao,
      tipo,
      metodo,
      protocolo,
      dataAtivacao,
    });

    return response;
  },

  listarSistemasIntegrados: async (
    context,
    {
      clienteId,
      unidadeId,
      sistemaUuid,
      versao,
      tipo,
      metodo,
      protocolo,
      dataAtivacao,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`bko/integracao/unidade-sistema`, {
      params: {
        clienteId,
        unidadeId,
        sistemaUuid,
        versao,
        tipo,
        metodo,
        protocolo,
        dataAtivacao,
      },
    });

    return response;
  },

  // Monitoramento Integrações
  listarTotalRequisicoesIntegradas: async (
    context,
    { clienteId, unidadeId, tipo, dataEnvio }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(
      `bko/monitoramento/integracao/total-requisicoes-integradas`,
      {
        params: {
          clienteId,
          unidadeId,
          tipo,
          dataEnvio,
        },
      }
    );

    return response;
  },

  listarTotalErros: async (
    context,
    { clienteId, unidadeId, tipo_erro, data_envio }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(
      `bko/monitoramento/integracao/listagem-erros`,
      {
        params: {
          clienteId,
          unidadeId,
          tipo_erro,
          data_envio,
        },
      }
    );

    return response;
  },

  listarClientesPorSistema: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`bko/integracao/clientes-por-sistema`);

    return response;
  },

  listarIntegracoesPorTipo: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(
      `bko/integracao/sistemas/quantidade-por-tipo`
    );

    return response;
  },
  listarUnidades: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;

    let response = await api.get(`/bko/cliente/${clienteId}/unidade`);

    return response;
  },
  usuariosAtivos: async (context, { clienteId, unidadeId }) => {
    const api = context.rootState.autenticacao.api;

    let response = await api.get(`/bko/monitoramento/cliente/usuarios-ativos`, {
      params: {
        clienteId,
        unidadeId,
      },
    });

    return response;
  },

  listarMaquinaEspecifica: async (context, { clienteId, unidadeId }) => {
    const api = context.rootState.autenticacao.api;

    let response = await api.get(
      `/bko/cliente/${clienteId}/unidade/${unidadeId}/requisitantes`
    );

    return response;
  },

  //Monitoramento Geral
  receberDadosMonitoramentoGeral: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`/bko/monitoramento/cliente`, {
      params: {
        // unidadeId,
        // clienteId,
      },
    });

    return response;
  },

  receberDadosMonitoramentoUsuariosAtivosPorUnidade: async (
    context,
    { unidadeId, clienteId }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(
      `/bko/monitoramento/cliente/usuarios-ativos`,
      {
        params: {
          unidadeId,
          clienteId,
        },
      }
    );

    return response;
  },

  // Cadastro de Job por cliente
  listarComandos: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`bko/mensageria/listar`);

    return response;
  },

  listarAgendamentosCriados: async (context, { clienteId, tipo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`bko/mensageria/agendamentos`, {
      params: {
        clienteId,
        tipo,
      },
    });

    return response;
  },

  agendarComando: async (
    context,
    { clienteId, modeloId, cronExpression, parametros }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`bko/mensageria/agendar`, {
      clienteId,
      modeloId,
      cronExpression,
      parametros,
    });

    return response;
  },

  enviarComando: async (context, { clienteId, modeloNome, corpo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`bko/mensageria/enviar`, {
      clienteId,
      modeloNome,

      corpo,
    });

    return response;
  },

  excluirCriado: async (context, { clienteId, modeloId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `bko/mensageria/${clienteId}/${modeloId}`
    );

    return response;
  },

  // Visualização de logs

  listarLogsJob: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`bko/job/log`);

    return response;
  },

  //Gestao de Menus
  listarSubmenus: async (context, { nome, descricao, perPage, page }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get("bko/gestao-menus/submenu", {
      params: {
        nome,
        descricao,
        perPage,
        page,
      },
    });

    return response;
  },

  criarSubmenu: async (
    context,
    { nome, indice, nomeVisualizacao, descricao, icone }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post("bko/gestao-menus/submenu", {
      nome,
      indice,
      nomeVisualizacao,
      descricao,
      icone,
    });

    return response;
  },

  editarSubmenu: async (
    context,
    { submenuId, descricao, nomeVisualizacao, indice, icone }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`bko/gestao-menus/submenu/${submenuId}`, {
      descricao,
      nomeVisualizacao,
      indice,
      icone,
    });

    return response;
  },

  vincularPerfilCliente: async (
    context,
    { submenuId, perfil, cliente, nomeVisualizacao, indice }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `bko/gestao-menus/submenu/${submenuId}/perfil/${perfil}/vincular`,
      {
        cliente,
        nomeVisualizacao,
        indice,
      }
    );

    return response;
  },

  vincularPagina: async (context, { submenuId, paginaNome }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `bko/gestao-menus/submenu/${submenuId}/pagina/${paginaNome}/vincular`
    );

    return response;
  },

  desvincularPagina: async (context, { submenuId, paginaNome }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `bko/gestao-menus/submenu/${submenuId}/pagina/${paginaNome}/desvincular`
    );

    return response;
  },

  desvincularPerfilCliente: async (context, { submenuId, perfil, cliente }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `bko/gestao-menus/submenu/${submenuId}/perfil/${perfil}/desvincular`,
      {
        cliente,
      }
    );

    return response;
  },

  excluirSubmenu: async (context, { submenuId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`bko/gestao-menus/submenu/${submenuId}`);

    return response;
  },

  detalharSubmenu: async (context, { submenuId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(
      `bko/gestao-menus/submenu/${submenuId}/detalhar`
    );

    return response;
  },

  listarPaginas: async (context, { nome, rota, descricao, perPage, page }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get("bko/gestao-menus/pagina", {
      params: {
        nome,
        rota,
        descricao,
        perPage,
        page,
      },
    });

    return response;
  },

  criarPagina: async (context, { nome, rota, descricao, icone }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post("bko/gestao-menus/pagina", {
      nome,
      rota,
      descricao,
      icone,
    });

    return response;
  },

  criarPaginaEmMassa: async (context, { paginas }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(
      "bko/gestao-menus/pagina/criacao-em-massa",
      {
        paginas,
      }
    );

    return response;
  },

  editarPagina: async (context, { paginaNome, descricao, icone }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`bko/gestao-menus/pagina/${paginaNome}`, {
      descricao,
      icone,
    });

    return response;
  },

  excluirPagina: async (context, { paginaNome }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`bko/gestao-menus/pagina/${paginaNome}`);

    return response;
  },

  listarParametrizacoes: async (context, { clienteId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`bko/parametrizacao`, {
      params: {
        clienteId,
      },
    });

    return response;
  },

  editarParametrizacao: async (
    context,
    { clienteId, parametrizacaoId, schema }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`bko/parametrizacao`, {
      clienteId,
      parametrizacaoId,
      schema,
    });

    return response;
  },

  listarTurnos: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vendor-shifts`, {
      params: {
        vendor_id,
      },
    });

    return response;
  },

  criarTurno: async (
    context,
    { description, finish_time, start_time, vendor_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`vendor-shifts`, {
      vendor_id,
      description,
      finish_time,
      start_time,
    });

    return response;
  },
  deletarTurno: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`vendor-shifts/${id}`, {});

    return response;
  },
  removerChaveFacial: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`biometria/credencial/${uuid}`, {});

    return response;
  },

  ativarChaveFacial: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `biometria/credencial/ativar-credencial/${uuid}`,
      {}
    );

    return response;
  },

  desativarChaveFacial: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `biometria/credencial/desativar-credencial/${uuid}`,
      {}
    );

    return response;
  },

  editarChaveFacial: async (context, { key, secret, uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`biometria/credencial/${uuid}`, {
      key,
      secret,
    });

    return response;
  },

  criarChaveFacial: async (context, { tenant, key, secret }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`/biometria/credencial`, {
      tenant,
      key,
      secret,
    });

    return response;
  },

  listarChavesFacial: async (
    context,
    { uuid, tenant, key, secret, status, dataInicia, dataFinal, excluido }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`biometria/credencial`, {
      params: {
        uuid,
        tenant,
        key,
        secret,
        status,
        dataInicia,
        dataFinal,
        excluido,
      },
    });

    return response;
  },

  monitoramentoNats: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;
    // Remove /apiv2 da URL base para acessar a raiz
    const baseURL = api.defaults.baseURL.replace("/apiv2", "");
    try {
      const response = await api.get(`nats-monitoring`, {
        baseURL: baseURL,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        withCredentials: false,
      });

      return response;
    } catch (error) {
      console.error("Erro ao buscar dados do NATS:", error);
      throw error;
    }
  },

  listarMensagensPorSubject: async (context, { subject, page, limit }) => {
    const api = context.rootState.autenticacao.apiNats;
    const response = await api.get(`messages/subject/${subject}`, {
      params: {
        page,
        limit,
      },
    });

    return response;
  },
};

export const office = {
  namespaced: true,
  actions,
};
